import {
    Flex,
    useStyles,
    Pagination,
    PaginationItem,
} from '@archipro-design/aria';
import type { PaginationItemCounterProps } from '@archipro-design/aria';

import { Link, useLocation, useSearchParams } from 'react-router';
import * as S from './PaginatedVideos.style';

import VideoGrid from '@modules/professional/component/video-tab/VideoGrid';
import VideoSort from '@modules/professional/component/video-tab/VideoSort';
import type { PaginatedVideosProps } from '../../api/list-professional-videos.server';

const PaginatedVideosMobile: React.FC<PaginatedVideosProps> = ({
    videos,
    totalCount,
    totalPage,
    currentPage,
    pageSize,
    initialSort,
    hasPreviousPage,
    hasNextPage,
}) => {
    const { css } = useStyles({ hasPagination: totalPage > 1 });

    const location = useLocation();

    const [searchParams] = useSearchParams();

    const renderPaginationLink = (page: number | null) => {
        const copyParams = new URLSearchParams(searchParams);

        if (page) {
            copyParams.set('page', page.toString());
        }

        return `${location.pathname}?${copyParams.toString()}`;
    };

    return (
        <div className={css(S.VideoSection)}>
            <Flex column={true} className={css(S.Container)}>
                <Flex className={css(S.FilterBar)}>
                    <VideoSort
                        initialSort={initialSort}
                        itemCount={totalCount}
                    />
                </Flex>
                <VideoGrid videos={videos} />
                <Flex
                    className={css(S.PaginationWrapper)}
                    hAlign="center"
                    fill={true}
                >
                    {totalPage > 1 && (
                        <Pagination
                            appDisplayMode={{
                                mobile: true,
                                desktop: false,
                            }}
                            className={css(S.PaginationMobile)}
                            prevButton={{}}
                            nextButton={{}}
                            renderItem={(item) => {
                                const disablePrev =
                                    item.type === 'previous' &&
                                    !hasPreviousPage;
                                const disableNext =
                                    item.type === 'next' && !hasNextPage;

                                if (disablePrev || disableNext) {
                                    return PaginationItem.create(
                                        {
                                            content: item,
                                        },
                                        { generateKey: true },
                                    );
                                }

                                return PaginationItem.create({
                                    as: Link,
                                    key: `paginationItem-${item.type}-${item.page}`,
                                    prefetch: 'intent',
                                    to: renderPaginationLink(item.page),
                                    content: item,
                                });
                            }}
                            defaultPage={currentPage}
                            count={totalPage}
                            counter={{
                                range: {
                                    from: (currentPage - 1) * pageSize + 1,

                                    to:
                                        currentPage * pageSize > totalCount
                                            ? totalCount
                                            : currentPage * pageSize,
                                },
                                total: totalCount,
                                textRenderer: (
                                    range: PaginationItemCounterProps['range'],
                                    total: PaginationItemCounterProps['total'],
                                ) =>
                                    `${range.from} - ${range.to} of ${total} Videos`,
                            }}
                            totalCount={totalCount}
                            pageSize={pageSize}
                        />
                    )}
                </Flex>
            </Flex>
        </div>
    );
};

export default PaginatedVideosMobile;
